import styled from "styled-components";
import {Flex} from "../../../assets/ui";
import {StyledButton} from "../../../components/common/Button";

export const ModalBody = styled(Flex)`
  flex-direction: column;
  padding: 16px;
  width: 90vw;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  margin: 45px 0;
  max-width: 800px;
  background: #ffffff;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.24);
  border-radius: 4px;

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 36px 70px 40px 50px;
  }
`;

export const StyledModal = styled(Flex)`
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;

  z-index: 44;
  overflow-y: auto;
  background: rgba(35, 50, 71, 0.48);
`;

export const SubtitleBlock = styled.p`
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #586981;
  margin-bottom: 26px;
`;

export const TitleGroup = styled.h3`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 20px;

  color: #586981;
`;

export const CancelButton = styled(StyledButton)`
  background: none;
  width: 100%;
  border: 1px solid #586981;
  color: #586981;
`;

export const CloseBtn = styled.button`
  background: none;
  cursor: pointer;

  & > svg {
    width: 18px;
    height: 18px;
  }
`;

export const StyledSuccessModal = styled(ModalBody)`
  flex-direction: column;
  align-items: center;
  max-width: 450px;
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #586981;
  padding: 16px 16px 24px 16px;

  @media (min-width: ${({ theme }) => theme.queries.md}) {
    padding: 26px 20px 46px;
    background-image: url("/images/thanks-modal-bg.png");
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const TitleBlock = styled.h3`
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 20px;
  color: #233247;
`;
